/**
 * Point Spot (Reward Pin) Constants
 * 
 * Defines Remote Config keys, default values, and internal constraints.
 */
export const POINT_SPOT_CONSTANTS = {
    // Remote Config Keys
    RC_KEYS: {
        ENABLED: 'point_spot_enabled',
        DAILY_LIMIT: 'point_spot_daily_limit',
        REWARD_BASIC: 'point_spot_reward_basic',
        REWARD_AD: 'point_spot_reward_ad'
    },

    // Default Values (Fallbacks)
    DEFAULTS: {
        ENABLED: true,
        DAILY_LIMIT: 10,
        REWARD_BASIC: 0.0314, // SPOT
        REWARD_AD: 0.314      // SPOT
    },

    // Generation Settings (Client-Side)
    GEN: {
        GRID_SIZE_DEG: 0.0005, // Approx 55m (Lat/Lng degrees) - 100m radius covers ~13 grids
        RADIUS_M: 500,         // Search radius (Internal generation radius)
        PROBABILITY: 0.35,     // 35% chance per grid - Target ~4.5 spots in 100m
        LANDMARK_BOX_RADIUS_M: 100,  // 랜드마크 중심 반경 100m 이내에 5개
        LANDMARK_BOX_COUNT: 5
    },

    // UI Settings
    Z_INDEX: 300, // Higher than Store(100), Lower than User(400)
};

export default POINT_SPOT_CONSTANTS;
